import corporateRequest from 'utils/corporateRequest'
import ErrorMessage from 'utils/ErrorMessage'
import instRequest from 'utils/instRequest'
import SuccessMessage from '../../utils/SuccessMessage'
export const SET_ROLES_LIST = 'institute/SET_ROLES_LIST'
export const SET_RULE_ENGINE = 'institute/SET_RULE_ENGINE'
export const SET_CORP_LIST = 'institute/SET_CORP_LIST'
export const SET_RULE_LIST = 'institute/SET_RULE_LIST'
export const SET_RULE_LIST_WAY = 'institute/SET_RULE_LIST_WAY'
export const SET_RULE_DETAILS = 'institute/SET_RULE_DETAILS'
export const SET_ALREADY_SET_DEGREE_LIST =
  'institute/SET_ALREADY_SET_DEGREE_LIST'
export const SET_RULES_DEGREES_METRICS = 'institute/SET_RULES_DEGREES_METRICS'
export const SET_SELECTED_DEGREE_DEPARTMENT = 'SET_SELECTED_DEGREE_DEPARTMENT'
export const SET_DEGREE_STREAM_MAP = 'institute/SET_DEGREE_STREAM_MAP'
export const SET_RULES_STATIC_DETAILS = 'institute/SET_RULES_STATIC_DETAILS'
export const SET_IS_RULES_EDITED = 'institute/SET_IS_RULES_EDITED'
export const setRolesList = data => {
  return {
    type: SET_ROLES_LIST,
    data,
  }
}
export const setRuleEngine = data => {
  return {
    type: SET_RULE_ENGINE,
    data,
  }
}
export const setCorporateList = data => {
  return {
    type: SET_CORP_LIST,
    data,
  }
}

export const getRuleEngine = () => async (dispatch, getState) => {
  const state = getState()
  const institute_id = state?.auth?.instituteDetails?.id
  if (!institute_id) return
  try {
    const info = await instRequest.get(`/institutes/${institute_id}/rule`)

    if (info?.status === 200) {
      dispatch(setRuleEngine(info?.data?.data))
    }
  } catch (error) {
    ErrorMessage(error?.response?.data?.message)
  }
}
